import { useRecordContext } from "ra-core";
import { MapPin } from "lucide-react";
import type { Contact } from "../types";
import { formatContactAddress, hasContactAddress } from "./contactModel";

export const ContactAddress = () => {
  const record = useRecordContext<Contact>();
  if (!record || !hasContactAddress(record)) return null;

  return (
    <div className="flex flex-row items-start gap-2 min-h-6">
      <MapPin className="w-4 h-4 mt-0.5 text-muted-foreground" />
      <div className="text-sm">
        {formatContactAddress(record).map((line) => (
          <div key={line}>{line}</div>
        ))}
      </div>
    </div>
  );
};
